import "./WhatsAppFloatingButton.css";
import whatsappIcon from "_+_Portal/assets/images/generico/whatsapp-icon.png";
import isAuthenticated from "global/utils/isAuthenticated";

const WHATSAPP_URL = "https://wa.me/5491166485555";

const WhatsAppFloatingButton = () => {
  let config = localStorage.getItem("config");
  let opcBot = config ? JSON.parse(config).opcBot : false;

  if (opcBot === false || !isAuthenticated()) return null;

  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-floating-btn"
      aria-label="Contactar por WhatsApp"
    >
      <img src={whatsappIcon} alt="WhatsApp" />
    </a>
  );
};

export default WhatsAppFloatingButton;
